// @flow

import React from 'react'
import {connect} from 'react-redux'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import moment from 'moment'
import {appSelectors} from '@/store'
import type {Language} from '@/types'
import {dateFormatBasedOnCountry} from '@/defaults'
import {getElementIdName} from '@/views/util'
import './date-range-picker.css'

type Props = {
  l: Language,
  value: any,
  label: string,
  disable: ?boolean,
  onChange: (any) => void,
  isEditMode: boolean,
  langCode: string,
}

export const RawDateRangePicker = (props: Props) => {
  const handleEvent = (props) => (event, picker) => {
    if (event.type === 'apply') {
      const {startDate} = picker
      props.onChange(moment(startDate).format(dateFormatBasedOnCountry(props.langCode)))
    }
  }

  return (
    <div className='form-group'>
      <label>{props.l(props.label)}
        {props.disable
          ? <input className='form-control' value={props.value} placeholder={dateFormatBasedOnCountry(props.langCode)} disabled={true}/>
          : <DateRangePicker
            singleDatePicker={true}
            startDate={props.value}
            minDate={props.isEditMode ? '' : moment().format(dateFormatBasedOnCountry(props.langCode))}
            onEvent={handleEvent(props)}
            opens="right"
            locale={{
              format: dateFormatBasedOnCountry(props.langCode),
              cancelLabel: props.l('Cancel'),
              applyLabel: props.l('Apply'),
            }}
          >
            <input type='text' className='form-control' id={getElementIdName(props.label)} value={props.value} placeholder={dateFormatBasedOnCountry(props.langCode)}/>
          </DateRangePicker> }
      </label>
    </div>
  )
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
  langCode: state.app.user.preferredLanguageCode,
})

export default connect(
  mapStateToProps,
)(RawDateRangePicker)



// WEBPACK FOOTER //
// ./src/elements/date-picker.js